import React, { useState } from 'react';
import { Button, Form, Container, Row, Col, Table, Alert } from 'react-bootstrap';

const AddSizeComponent = () => {
  const [sizeData, setSizeData] = useState({
    categoryName: '',
    subCategoryName: '',
    sizeName: '',
  });

  const [sizeList, setSizeList] = useState([
    { id: 1, name: '55 Inch (140 CM)' },
    { id: 2, name: '43 Inch (109 CM)' },
    { id: 3, name: '15 LTR' },
    { id: 4, name: '55 INCH' },
    { id: 5, name: '43 INCH' },
    { id: 6, name: '300 ML' },
  ]);

  const [showAlert, setShowAlert] = useState({ visible: false, message: '', variant: '' });

  const handleInputChange = (e) => {
    setSizeData({
      ...sizeData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddSize = (e) => {
    e.preventDefault();
    if (sizeData.sizeName.trim()) {
      setSizeList([...sizeList, { id: sizeList.length + 1, name: sizeData.sizeName }]);
      setSizeData({ categoryName: '', subCategoryName: '', sizeName: '' });
      setShowAlert({ visible: true, message: 'Size added successfully!', variant: 'success' });
    } else {
      setShowAlert({ visible: true, message: 'Please fill out the size name.', variant: 'danger' });
    }
  };

  const handleDeleteSize = (id) => {
    setSizeList(sizeList.filter((size) => size.id !== id));
    setShowAlert({ visible: true, message: 'Size deleted successfully!', variant: 'warning' });
  };

  return (
    <Container className="mt-5">
      <h3 className="text-center mb-4">Create Size</h3>

      {/* Alert Messages */}
      {showAlert.visible && (
        <Alert
          variant={showAlert.variant}
          onClose={() => setShowAlert({ visible: false, message: '', variant: '' })}
          dismissible
        >
          {showAlert.message}
        </Alert>
      )}

      {/* Create Size Form */}
      <Form onSubmit={handleAddSize} className="mb-4">
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="formCategoryName">
              <Form.Label>Category Name</Form.Label>
              <Form.Control
                as="select"
                name="categoryName"
                value={sizeData.categoryName}
                onChange={handleInputChange}
                required
              >
                <option>Select Category</option>
                <option>Electronics</option>
                <option>Apparel</option>
                <option>Furniture</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="formSubCategoryName">
              <Form.Label>Sub Category Name</Form.Label>
              <Form.Control
                as="select"
                name="subCategoryName"
                value={sizeData.subCategoryName}
                onChange={handleInputChange}
                required
              >
                <option>Select SubCategory</option>
                <option>Smart TV</option>
                <option>Shirts</option>
                <option>Chairs</option>
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={12}>
            <Form.Group controlId="formSizeName">
              <Form.Label>Size Name</Form.Label>
              <Form.Control
                type="text"
                name="sizeName"
                value={sizeData.sizeName}
                onChange={handleInputChange}
                placeholder="Enter Size Name"
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <div className="d-flex justify-content-end">
          <Button variant="primary" type="submit" className="me-2">
            Create Size
          </Button>
          <Button
            variant="secondary"
            onClick={() => setSizeData({ categoryName: '', subCategoryName: '', sizeName: '' })}
          >
            Cancel
          </Button>
        </div>
      </Form>

      {/* Size List Table */}
      <h3 className="text-center mb-4">Size List</h3>
      <Table striped bordered hover responsive className="shadow-sm">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Size Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {sizeList.map((size, index) => (
            <tr key={size.id}>
              <td>{index + 1}</td>
              <td>{size.name}</td>
              <td>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleDeleteSize(size.id)}
                  className="me-2"
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default AddSizeComponent;
